/**
 * 删除el-tooltip的poper元素
 */
const removeTooltip = function () {
  const eles = document.querySelectorAll('.el-tooltip__popper')
  if (eles && eles.length > 0) {
    eles.forEach((e) => e.remove && e.remove())
  }
}

export default removeTooltip
